import { AlertRule, CompRiskLevel } from '@/api';
import { AlertRuleType } from '@/api/complianceAPI/models';

import { RiskKeys } from '@/config/riskSignals';

export const behavioralAlertsDemoData: AlertRule[] = [
  {
    id: 1,
    name: 'A very long name of the Rule #1',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.Low,
    direction: 'income',
    categories: [RiskKeys.DECENTRALIZED_EXCHANGE_CONTRACT],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
  {
    id: 2,
    name: 'Rule #2',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.Medium,
    direction: 'outcome',
    categories: [RiskKeys.TRUSTED_EXCHANGE],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
  {
    id: 3,
    name: 'Rule #3',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.Medium,
    direction: 'income',
    categories: [RiskKeys.MINER],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: false,
  },
  {
    id: 4,
    name: 'Rule #4',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.EXCHANGE_MLRISK_LOW],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
  {
    id: 5,
    name: 'Rule #5',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.EXCHANGE_FRAUDULENT],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: false,
  },
  {
    id: 6,
    name: 'Rule #6',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.TERRORISM_FINANCING],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
  {
    id: 7,
    name: 'Rule #7',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.WALLET],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: false,
  },
  {
    id: 8,
    name: 'Rule #8',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.PAYMENT],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
  {
    id: 9,
    name: 'Rule #9',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.High,
    direction: 'income',
    categories: [RiskKeys.PAYMENT],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: false,
  },
  {
    id: 10,
    name: 'Rule #10',
    type: AlertRuleType.TX_COUNT,
    risk: CompRiskLevel.Medium,
    direction: 'income',
    categories: [RiskKeys.MARKETPLACE],
    categoryJoin: 'all',
    params: {
      count: 10,
      intervalType: 'minute',
      intervalValue: 1,
      minAmount: 100,
      maxAmount: 1000,
    },
    isActive: true,
  },
];
